import React, { useEffect, useState } from "react";
import "./App.css";
import Router from "./router/router";
import { RouterProvider } from "react-router-dom";
import { useAppDispatch } from "./services/redux/hooks/hooks";
import {
  InteractionStatus,
  IPublicClientApplication,
} from "@azure/msal-browser";
import {
  AuthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import { loginRequest } from "./services/msalAuth/authConfig";
import Navbar from "./components/navbar";

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (inProgress === InteractionStatus.None && !isAuthenticated) {
    localStorage.setItem("authHandler", "1");
    instance.loginRedirect(loginRequest).catch((error: any) => {
      console.log(error);
    });
  }

  return (
    <div className="w-full h-full flex flex-nowrap">
      {/* <div className='basis-[15%] grow-0 shrink-0'>
        <Navbar></Navbar>
      </div> */}
      {/* <div className='basis-[100%] grow-0 shrink-0'> */}
      <AuthenticatedTemplate>
        <Router />
      </AuthenticatedTemplate>
      {/* </div> */}
    </div>
  );
}

export default App;
